export default __webpack_public_path__ + "assets/TKO for IG post.88deb833.PNG";